import { useAuth } from '~/hooks/useAuth';
import PanelActividad from './PanelActividad';

/** La actividad de la empresa de quien ha iniciado sesión. */
const ActividadPage = () => {
  const { user } = useAuth();
  return <PanelActividad companyId={user?.company?.id} />;
};

export default ActividadPage;
